import ReactDateRangePicker from 'components/ReactDateRangePicker/ReactDateRangePicker';
import moment from 'moment-timezone';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDebouncedCallback } from 'use-debounce';



import excelIcon from '../../assets/img/icons/excel-green.svg';
import AddSingleMemberDropdown from '../../components/CustomDropdown/AddSingleMemberDropdown';
import CreateProjectDropdown from '../../components/DropdownStyle/CreateProjectDropdown';
import ButtonTextLoader from '../../components/Loaders/ButtonTextLoader';
import BottomPagination from '../../components/Pagination/BottomPagination/BottomPagination';
import TopPagination from '../../components/Pagination/TopPagination/TopPagination';
import Select from '../../components/ReactSelectDropdown';
import { filterOption } from '../../components/ReactSelectDropdown/ReactSelectDropdown';
import SearchWithButton from '../../components/Search/SearchWithButton';
import DatePicker from '../../components/SingleDatePicker/SingleDatePicker';
import { ButtonIcon, ColoredButton, PrimaryButton, WhiteButtonWithIcon } from '../../styledComponents/buttons';
import { CommonFlex, CommonFlexWrap, FilterLabel, HeaderContainer, InputField, InputWithLabelSection, PageTitle } from '../../styledComponents/common';
import { TabLeftGrid } from '../../styledComponents/members';
import { exportToExcel } from '../../utils/exportToExcel';
import ClockInOutTable from './ClockInOutTable';



const ClockInOut = props => {
  const [selectedDate, setSelectedDate] = useState(moment());
  const [startDate, setStartDate] = useState(
    moment().startOf('week').format('YYYY-MM-DD'),
  );
  const [endDate, setEndDate] = useState(
    moment().endOf('week').format('YYYY-MM-DD'),
  );

  const [selectedOffice, setSelectedOffice] = useState({ value: null, label: 'All Offices' });
  const [officeOptions, setOfficeOptions] = useState([{ value: null, label: 'All Offices' }]);

  const [selectedPublicZone, setSelectedPublicZone] = useState({ value: null, label: 'All Zones' });
  const [publicZoneOptions, setPublicZoneOptions] = useState([{ value: null, label: 'All Zones' }]);

  const [selectedLocation, setSelectedLocation] = useState({ value: null, label: 'All Location' });
  const [locationOptions, setLocationOptions] = useState([{ value: null, label: 'All Location' }]);

  const [selectedAssignee, setSelectedAssignee] = useState(null);
  const [assigneeOptions, setAssigneeOptions] = useState([]);

  const [searchTerm, setSearchTerm] = useState('');
  const [currentSearchedTerm, setCurrentSearchedTerm] = useState('');
  const [attendanceList, setAttendanceList] = useState([]);

  const [reportLoading, setReportLoading] = useState(false);
  const [allReportLoading, setAllReportLoading] = useState(false);
  const [dateChanged, setDateChanged] = useState(false);
  const [expandedAttendanceId, setExpandedAttendanceId] = useState(null);
  const [transformedClockInOutList, setTransformedClockInOutList] = useState([]);
  const [isTransforming, setIsTransforming] = useState(false);

  const { t } = useTranslation();

  // pagination
  const [currentPageNumber, setCurrentPageNumber] = useState(1);

  const {
    history,
    isLoading,
    getClockInOutList,
    clockInOutList,

    getOfficesShortList,
    officesShortList,

    getPublicZoneList,
    publicZoneList,

    getTaskLocation,
    locationsList,

    getOrganizationMembersList,
    orgMembersList,

    // pagination
    clockInOutListCount,
    clockInOutPageSize,
  } = props;

  useEffect(() => {
    getOfficesShortList();
    getPublicZoneList();
    getTaskLocation();
    getOrganizationMembersList();
  }, []);

  const  getData = () => {
    const payload = {
      start_timestamp: moment(startDate).startOf('day').unix(),
      end_timestamp: moment(endDate).endOf('day').unix(),
    };
    
    if (currentSearchedTerm) {
      payload.name = currentSearchedTerm.toLocaleLowerCase().trim();
    }
    
    if (currentPageNumber && currentPageNumber > 1) {
      payload.page = currentPageNumber;
    }
    
    if (selectedOffice?.value) {
      payload.office = selectedOffice.value;
    }
    
    if (selectedPublicZone?.value) {
      payload.public_zone = selectedPublicZone.value;
    }
    
    if (selectedLocation?.value) {
      payload.location = selectedLocation.value;
    }
    
    if (selectedAssignee?.id) {
      payload.assignee = selectedAssignee.id;
    }
    
    getClockInOutList(payload);}

  // Fetch clock in/out data when filters or pagination changes
  useEffect(() => {
    getData();
  }, [dateChanged, selectedOffice, selectedPublicZone, selectedLocation, selectedAssignee, currentPageNumber]);

  useEffect(() => {
    // Initialize public zone options from API
    if (publicZoneList && publicZoneList.length > 0) {
      const publicZones = [
        { value: null, label: 'All Zones' },
        ...publicZoneList.map(zone => ({
          value: zone.id,
          label: zone.name,
        })),
      ];
      setPublicZoneOptions(publicZones);
    }
  }, [publicZoneList]);

  useEffect(() => {
    // Initialize location options from API
    if (locationsList && locationsList.length > 0) {
      const locations = [
        { value: null, label: 'All Location' },
        ...locationsList.map(location => ({
          value: location.id,
          label: location.name,
        })),
      ];
      setLocationOptions(locations);
    }
  }, [locationsList]);

  useEffect(() => {
    if (officesShortList && officesShortList.length > 0) {
      let newArr = [
        { value: null, label: 'All Offices' },
      ];
      officesShortList.forEach((office, i) => {
        newArr.push({
          label: office.name,
          value: office.id,
        });
      });
      setOfficeOptions(newArr);
    }
  }, [officesShortList]);

  useEffect(() => {
    // Initialize assignee options from API
    if (orgMembersList && orgMembersList.length > 0) {
      // Keep assignee as null initially, don't set default
    }
  }, [orgMembersList]);

  // useEffect(() => {
  //   if (clockInOutList && clockInOutList.length > 0) {
  //     // console.log(clockInOutList);
  //     const newAttendances = [];
  //     clockInOutList.forEach(element => {
  //       if (element.attendances && element.attendances.length > 1) {
  //         let newList = element.attendances.sort(
  //           (a, b) => a.timestamp - b.timestamp,
  //         );

  //         let i = 0;
  //         while (i < newList.length) {
  //           const data = {
  //             employee: element.employee,
  //             attendance: {},
  //           };
  //           let iteratorValue = 1;
  //           if (newList[i].type === 'clock_in') {
  //             data.attendance.clockIn = newList[i];
  //             if (newList[i + 1] && newList[i + 1].type === 'clock_out') {
  //               data.attendance.clockOut = newList[i + 1];
  //               iteratorValue = 2;
  //             }
  //           } else if (newList[i].type === 'clock_out') {
  //             data.attendance.clockOut = newList[i];
  //             data.attendance.clockIn = null;
  //           }

  //           newAttendances.push(data);
  //           i = i + iteratorValue;
  //         }
  //       } else if (element.attendances && element.attendances.length === 1) {
  //         const data = {
  //           employee: element.employee,
  //           attendance: {},
  //         };
  //         if (element.attendances[0].type === 'clock_in') {
  //           data.attendance.clockIn = element.attendances[0];
  //           data.attendance.clockOut = null;
  //         } else if (element.attendances[0].type === 'clock_out') {
  //           data.attendance.clockIn = null;
  //           data.attendance.clockOut = element.attendances[0];
  //         }
  //         newAttendances.push(data);
  //       }
  //     });
  //     setAttendanceList(newAttendances);
  //   }
  // }, [clockInOutList]);


  // Transform clockInOutList by grouping attendances by office_id + public_zone_id
  const transformClockInOutData = (data) => {
    if (!data || !Array.isArray(data)) {
      return [];
    }

    const transformedList = [];

    data.forEach(item => {
      const attendances = item.attendances || [];
      
      // Group attendances by office_id + public_zone_id combination
      const grouped = {};
      
      attendances.forEach(attendance => {
        const key = `${attendance.office_id}|${attendance.public_zone_id}`;
        if (!grouped[key]) {
          grouped[key] = {
            office_id: attendance.office_id,
            public_zone_id: attendance.public_zone_id,
            office: attendance.office,
            public_zone: attendance.public_zone,
            attendances: [],
          };
        }
        grouped[key].attendances.push(attendance);
      });

      // Convert grouped object to array of new items
      Object.values(grouped).forEach(group => {
        transformedList.push({
          employee: item.employee,
          location: {
            name: `${group.office} - ${group.public_zone}`,
            office_id: group.office_id,
            public_zone_id: group.public_zone_id,
          },
          attendances: group.attendances,
        });
      });
    });

    // Sort by office_id first, then by public_zone_id
    return transformedList.sort((a, b) => {
      if (a.location.office_id !== b.location.office_id) {
        return (a.location.office_id || '').localeCompare(b.location.office_id || '');
      }
      return (a.location.public_zone_id || '').localeCompare(b.location.public_zone_id || '');
    });
  };

  // Transform clockInOutList whenever it changes
  useEffect(() => {
    setIsTransforming(true);
    if (clockInOutList && clockInOutList.length > 0) {
      const transformed = transformClockInOutData(clockInOutList);
      setTransformedClockInOutList(transformed);
    } else {
      setTransformedClockInOutList([]);
    }
    setIsTransforming(false);
  }, [clockInOutList]);

  const handleSearchByName = () => {
    let name = '';
    if (searchTerm && searchTerm.trim()) {
      name = searchTerm.toLocaleLowerCase().trim();
      setCurrentSearchedTerm(searchTerm);
      setCurrentPageNumber(1);
    } else {
      setCurrentSearchedTerm('');
    }
  };
  const handleClearSearch = () => {
    setSearchTerm('');
    setCurrentSearchedTerm('');
    setCurrentPageNumber(1);
  };

  const handlePageChange = page => {
    setCurrentPageNumber(page);
  };

  const selectOffice = e => {
    setSelectedOffice(e);
    setCurrentPageNumber(1);
  };

  const selectPublicZone = e => {
    setSelectedPublicZone(e);
    setCurrentPageNumber(1);
  };

  const selectLocation = e => {
    setSelectedLocation(e);
    setCurrentPageNumber(1);
  };

  const onDateSelect = date => {
    setSelectedDate(date);
    setCurrentPageNumber(1);
  };

  const onSearchTermChange = e => {
    const { value } = e.target;
    setSearchTerm(value);
  };

  // updates date range when user picks from calendar
  const changeDateRange = dates => {
    setStartDate(dates.startDate);
    setEndDate(dates.endDate);
  };

  // selects last 7 days (including today)
  const selectLastWeek = () => {
    setStartDate(moment().subtract(6, "days").format("YYYY-MM-DD"));
    setEndDate(moment().format("YYYY-MM-DD"));
    setDateChanged(!dateChanged);
  };

  const onAssigneeSelect = person => {
    setSelectedAssignee(person);
    setCurrentPageNumber(1);
  };

  const clearAssignee = () => {
    setSelectedAssignee(null);
    setCurrentPageNumber(1);
  };

  // selects last 30 days (including today)
  const selectLastMonth = () => {
    setStartDate(moment().subtract(29, "days").format("YYYY-MM-DD"));
    setEndDate(moment().format("YYYY-MM-DD"));
    setDateChanged(!dateChanged);
  };

  // selects next week (future 7 days)
  const selectNextWeek = () => {
    setStartDate(moment().add(1, "days").format("YYYY-MM-DD"));
    setEndDate(moment().add(7, "days").format("YYYY-MM-DD"));
    setDateChanged(!dateChanged);
  };

  const handleExportToExcel = async () => {
    const url = `albait/export/attendances/?date=${moment(
      selectedDate,
    ).unix()}${selectedOffice?.value ? `&office=${selectedOffice.value}` : ''}`;

    setReportLoading(true);
    const response = await exportToExcel(url, null, true);
    setReportLoading(false);
  };

  const handleExportAllOfficesReportToExcel = useDebouncedCallback(
    async () => {
      const baseUrl = `albait/export/attendances/?date=${moment(
        selectedDate,
      ).unix()}`;

      if (officesShortList && officesShortList.length > 0) {
        setAllReportLoading(true);
        const delay = ms => new Promise(resolve => setTimeout(resolve, ms));

        const promises = [];
        officesShortList.forEach(async (office, i) => {
          const promise = (async index => {
            await delay(300 * index);
            const url = `${baseUrl}&office=${office.id}`;
            await exportToExcel(url, `office${office.name}.xlsx`, false);
          })(i);

          promises.push(promise);
        });

        await Promise.all(promises);

        setAllReportLoading(false);
      }
    },
    60000,
    { leading: true, trailing: false },
  );

  return (
    <div className="content">
      <PageTitle>{t('attendance')}</PageTitle>
      <HeaderContainer>
        {/* <TabLeftGrid columns="240px 240px"> */}
          {/* <SearchWithButton
            itemName="Member"
            searchTermName={t("member_name")}
            searchInput={searchTerm}
            onInputChange={onSearchTermChange}
            handleSearch={handleSearchByName}
            handleClearSearch={handleClearSearch}
          /> */}
          <CommonFlexWrap alignItems="end" flex-flow="row wrap">
           {localStorage.getItem('user_role') === 'admin' &&
          <InputWithLabelSection width="200px">
              <FilterLabel>{t('public_zone')}</FilterLabel>

              <Select
                isSearchable
                value={selectedPublicZone}
                options={publicZoneOptions}
                placeholder="Select Zone..."
                onChange={selectPublicZone}
                styles={CreateProjectDropdown()}
                // clearable
                filterOption={filterOption}
              />
            </InputWithLabelSection>}
          {/* <InputWithLabelSection width="200px">
              <FilterLabel>Location</FilterLabel>

              <Select
                isSearchable
                value={selectedLocation}
                options={locationOptions}
                placeholder="Select Location..."
                onChange={selectLocation}
                styles={CreateProjectDropdown()}
                // clearable
                filterOption={filterOption}
              />
            </InputWithLabelSection> */}
          {localStorage.getItem('user_role') === 'admin' && (
            <InputWithLabelSection width="200px">
              <FilterLabel>{t('office')}</FilterLabel>

              <Select
                isSearchable
                value={selectedOffice}
                options={officeOptions}
                placeholder="Select Office..."
                onChange={e => {
                  selectOffice(e);
                }}
                styles={CreateProjectDropdown()}
                // clearable
                filterOption={filterOption}
              />
            </InputWithLabelSection>
          )}
          <InputWithLabelSection>
              <FilterLabel>Assignee</FilterLabel>
              <div style={{ width: `40px` }}>
                <AddSingleMemberDropdown
                  assigneeManage={selectedAssignee}
                  updateState={onAssigneeSelect}
                  membersList={orgMembersList}
                  clearAssignee={() => clearAssignee()}
                />
              </div>
            </InputWithLabelSection>
          <InputWithLabelSection width="200px">
            <FilterLabel>{t('date_range')}</FilterLabel>
            <ReactDateRangePicker
                    startDate={startDate ? moment(startDate) : null}
                    startDateId="report-date-range-start-date"
                    endDate={endDate ? moment(endDate) : null}
                    endDateId="report-date-range-end-date"
                    onDatesChange={changeDateRange}
                    onDateSelect={() => {
                      setDateChanged(!dateChanged);
                    }}
                    selectLastWeek={selectLastWeek}
                    selectLastMonth={selectLastMonth}
                    selectNextWeek={selectNextWeek}
                    rangeRestricted={true}
                    disableFutureDates={false}
                  />
          </InputWithLabelSection>
        {/* </TabLeftGrid> */}
        </CommonFlexWrap>
        {/* <CommonFlex gap="12px">
          {localStorage.getItem('user_role') === 'admin' &&
          !localStorage.getItem('viewer_role') ? (
            <ColoredButton
              type="blue"
              onClick={() => handleExportAllOfficesReportToExcel()}
              padding={allReportLoading ? '0 45px' : '0 25px'}
            >
              {allReportLoading ? (
                <ButtonTextLoader color="#fff" loadingText=" " size={6} />
              ) : (
                <>{t('generate_all_report')}</>
              )}
            </ColoredButton>
          ) : null}
          {localStorage.getItem('user_role') !== 'employee' ||
          localStorage.getItem('user_role') !== 'supervisor' ? (
            <WhiteButtonWithIcon
              onClick={() => handleExportToExcel()}
              color="#19AC65"
              borderColor="#19AC65"
              hoverBorderColor="#129652"
              padding={reportLoading ? '0 45px' : '0 25px'}
            >
              {reportLoading ? (
                <ButtonTextLoader color="#19AC65" loadingText=" " size={6} />
              ) : (
                <>
                  <ButtonIcon src={excelIcon} size="26px" />
                  {t('export_report')}
                </>
              )}
            </WhiteButtonWithIcon>
          ) : null}
        </CommonFlex> */}
      </HeaderContainer>
      {clockInOutListCount && clockInOutListCount > 0 && clockInOutPageSize ? (
        <TopPagination
          itemName="members"
          totalCount={clockInOutListCount}
          currentPage={currentPageNumber}
          onPageChange={page => handlePageChange(page)}
          pageSize={clockInOutPageSize}
        />
      ) : null}
      <ClockInOutTable 
        clockInOutList={transformedClockInOutList} 
        isLoading={isLoading || isTransforming} 
        startDate={startDate}
        endDate={endDate}
        expandedAttendanceId={expandedAttendanceId}
        setExpandedAttendanceId={setExpandedAttendanceId}
      />
      {clockInOutListCount && clockInOutListCount > 0 && clockInOutPageSize ? (
        <BottomPagination
          totalCount={clockInOutListCount}
          currentPage={currentPageNumber}
          onPageChange={page => handlePageChange(page)}
          pageSize={clockInOutPageSize}
        />
      ) : null}
    </div>
  );
};

export default ClockInOut;